import { render } from "./packages-modal.vue?vue&type=template&id=233271ee"
import script from "./packages-modal.vue?vue&type=script&lang=js"
export * from "./packages-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__